<template>
  <div class="y-tree-menu">
    <div class="y-label-wrapper" @click="toggleChildren">
      <div :depth="depth" :class="labelClasses">
        <div class="y-label-text"><a :class="isActive" :href="'/products/' + slug + '/'" @click="updateScroll">{{ name }}</a></div>
      </div>
      <span v-if="children" class="y-cat-icons" :class="iconClasses"></span>
    </div>
      <tree-menu
          :key="child.name"
          v-if="showChildren"
          v-for="child in children"
          :children="child.children"
          :name="child.name"
          :slug="child.full_slug" 
          :depth="depth + 1"
      >
      </tree-menu>
  </div>
</template>
<script>

export default  {
  name: 'tree-menu',
  props: [ 'children', 'name', 'depth', 'slug' ],
  data() {
    return {
      showChildren: false,
      currentCategoryId: jQuery("#data-cat").data("cat"),
    }
  },
  computed: {
    isActive() {
      return {
        'y-isActiveCat' : this.showChildren
      }
    },
    iconClasses() {
      return {
        'dashicons dashicons-plus-alt2': !this.showChildren,
        'dashicons dashicons-minus': this.showChildren
      }
    },
    labelClasses() {
      return { 'y-has-children': this.children }
    }
  },
  methods: {
    updateScroll() {
      this.$store.commit('updateScrollYCat', window.scrollY);
    },
    toggleChildren() {
      this.showChildren = !this.showChildren;
    }
  },
  mounted() {
    (this.$store.state.currentSlug.startsWith(this.slug) ? this.showChildren = true : this.showChildren = false);
  }

};

</script>